import * as Yup from 'yup';

import { validateField, ValidationType } from './formValidation';
import type { AdminUserProfileFormInterface } from 'types';

export const adminUserProfileFormDefaultValues: AdminUserProfileFormInterface = {
    firstname: '',
    lastname: '',
    email: '',
};

export const buildSupportEmailValidationSchema = (requirePassword: boolean) =>
    Yup.object({
        support_email: validateField(ValidationType.EMAIL),
        // Blank keeps the current password when a mailbox is already configured.
        support_email_password: requirePassword
            ? Yup.string().trim().max(50).required()
            : Yup.string().trim().max(50),
    });

export type CheckEmailAvailableFn = (email: string) => Promise<boolean>;

export const buildAdminUserProfileValidationSchema = (
    checkEmailAvailable?: CheckEmailAvailableFn,
    originalEmail?: string
) => {
    const emailSchema = validateField(ValidationType.EMAIL).test(
        'check-email-availability',
        'Email is already in use',
        async (value) => {
            if (!value || typeof value !== 'string') return true;
            // Skip remote check when email unchanged
            if (
                originalEmail &&
                value.trim().toLowerCase() === originalEmail.trim().toLowerCase()
            ) {
                return true;
            }
            if (!checkEmailAvailable || !value.includes('@')) return true;
            return checkEmailAvailable(value);
        }
    );

    return Yup.object({
        firstname: validateField(ValidationType.STRING, false),
        lastname: validateField(ValidationType.STRING, false),
        email: emailSchema,
    });
};
